import React, {Component} from 'react';
import {connect} from 'react-redux';
import {DialogActions, DialogContentText, DialogContent, DialogTitle, Dialog, Button} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import ReduxGlobal from "../store/actionreducers/globalView";

class UecareAlertDialog extends Component {

    state = {
        open: false,
    };

    render() {

        const {closeAlertDialog, alertDialog} = this.props;

        return (
            <div>
                <Dialog
                    onClose={async () => {
                        if (alertDialog.noButton.onClick) await alertDialog.noButton.onClick();
                        closeAlertDialog();
                    }}
                    {...(alertDialog && alertDialog.props)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{alertDialog.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {alertDialog.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={async () => {
                            if (alertDialog.noButton.onClick) await alertDialog.noButton.onClick();
                            closeAlertDialog();
                        }}>
                            {alertDialog.noButton.label}
                        </Button>
                        <Button color="primary" autoFocus
                                onClick={async () => {
                                    if (alertDialog.yesButton.onClick) await alertDialog.yesButton.onClick();
                                    closeAlertDialog();
                                }}>
                            {alertDialog.yesButton.label}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeAlertDialog: ReduxGlobal.ActionCreator.closeAlertDialog,
    }, dispatch);
}

function mapStateToProps({global: {alertDialog}}) {
    return {alertDialog};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UecareAlertDialog));



// WEBPACK FOOTER //
// ./src/components/UecareAlertDialog.js